import { sageIllustrations } from "@/assets";
import { SectionHeader } from "@/components/layout/section-header";

function AppDownload() {
  return (
    <section
      className="mx-auto max-w-[1200px] grid grid-cols-1 items-center gap-8 px-5 py-14 min-[880px]:grid-cols-2 min-[880px]:gap-16 min-[880px]:py-20"
      id="app"
    >
      {/* Text */}
      <div>
        <SectionHeader
          title="Built for your pocket."
          subtitle="iOS & Android apps with passkey sign-in, Apple Pay, push notifications, and offline confirmations. Find chairs while you're already out."
        />
        <div className="flex flex-wrap gap-3">
          <a
            href="#app-store"
            className="inline-flex items-center gap-3 rounded-md bg-ink pl-4 pr-5 py-2.5 text-white no-underline transition-transform duration-short ease-default hover:scale-[1.02]"
          >
            <AppleIcon />
            <div className="flex flex-col leading-tight">
              <span className="text-[10px] opacity-80">Download on the</span>
              <span className="font-display text-[16px] font-medium">App Store</span>
            </div>
          </a>
          <a
            href="#google-play"
            className="inline-flex items-center gap-3 rounded-md bg-ink pl-4 pr-5 py-2.5 text-white no-underline transition-transform duration-short ease-default hover:scale-[1.02]"
          >
            <GooglePlayIcon />
            <div className="flex flex-col leading-tight">
              <span className="text-[10px] opacity-80">Get it on</span>
              <span className="font-display text-[16px] font-medium">Google Play</span>
            </div>
          </a>
        </div>
      </div>

      {/* Phone mockup */}
      <div className="relative flex min-h-[380px] items-center justify-center overflow-hidden rounded-lg bg-electric-50 px-5 py-10">
        <div className="relative w-[230px] aspect-[9/19] rounded-[36px] bg-ink p-2.5 shadow-pop">
          {/* Notch */}
          <div className="absolute left-1/2 top-3 z-10 -translate-x-1/2 rounded-pill w-[70px] h-[18px] bg-ink" />
          {/* Screen */}
          <div className="flex h-full flex-col overflow-hidden rounded-[28px] bg-paper">
            <div className="flex flex-1 flex-col items-center gap-4 px-5 pt-[60px]">
              <img src={sageIllustrations.wave} alt="" className="w-[110px]" />
              <h4 className="m-0 text-center font-display text-[16px] leading-tight">
                Tonight, near you.
              </h4>
              <span className="rounded-pill bg-electric px-3.5 py-1.5 text-[11px] font-bold text-white">
                184 chairs open
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function AppleIcon() {
  return (
    <svg className="size-7" viewBox="0 0 384 512" fill="#fff" aria-hidden="true">
      <path d="M318.7 268c-.5-69 56.4-102.1 59-103.7-32.2-47-82.3-53.4-100.1-54.1-42.5-4.3-83 25-104.7 25-21.7 0-54.9-24.4-90.4-23.7-46.5.7-89.5 27-113.4 68.7-48.4 83.9-12.3 207.9 34.7 276 23 33.3 50.4 70.6 86.4 69.3 34.7-1.4 47.8-22.4 89.6-22.4 41.9 0 53.6 22.4 90.4 21.7 37.4-.6 60.9-33.8 83.7-67.2 26.4-38.6 37.3-76 37.9-77.9-.8-.4-72.7-27.9-73.4-110.7zM261.1 71.8c19.2-23.3 32.1-55.6 28.6-87.8-27.6 1.1-61 18.4-80.8 41.6-17.7 20.6-33.2 53.5-29 85.1 30.7 2.4 62.1-15.6 81.2-38.9z" />
    </svg>
  );
}

function GooglePlayIcon() {
  return (
    <svg className="size-7" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M3.6 1.7a1.5 1.5 0 0 0-.8 1.3v18a1.5 1.5 0 0 0 .8 1.3l11-9.3-11-11.3z"
        fill="#34A853"
      />
      <path d="m14.6 13.3-11 9.3a1.5 1.5 0 0 0 1.6.1L17.5 16l-2.9-2.7z" fill="#FBBC05" />
      <path d="M17.5 16 20.6 14a1.5 1.5 0 0 0 0-2.6L17.5 9.5l-2.9 3.3 2.9 3.2z" fill="#EA4335" />
      <path d="m3.6 1.7 11 11.3 2.9-3.5L5.2 1.7a1.5 1.5 0 0 0-1.6 0z" fill="#4285F4" />
    </svg>
  );
}

export { AppDownload };
